import React from 'react';

export const NarrativeSummaryHelpComponent = () => {
    return (
        <div>
            <div>
                Please provide an English-language summary of the proposed research in &lt;500 words, that is suitable for a non-scientific
                or lay audience. Aim for a reading age of 12.
            </div>
            <div>Please include additional information regarding:</div>
            <ul>
                <li>
                    The project background, e.g. a brief description of the disease/condition in lay terms and how many members of the
                    public are potentially affected
                </li>
                <li>Explain in lay terms any necessary technical or field-specific language</li>
                <li>Necessity of the research (i.e. how the research will add to medical science or patient care)</li>
                <li>How the research will be conducted; (i.e. briefly describe what design and methods you have you chosen and why)</li>
                <li>Provide full form of all abbreviations in their first instance</li>
                <li>
                    For additional guidance on writing your lay summary, please see our video here:
                    <a href="https://youtu.be/lmTfVsU-sC4" target="_blank" rel="noopener noreferrer">
                        https://youtu.be/lmTfVsU-sC4
                    </a>
                </li>
                <li>Please note that this field is published on the Vivli website if the request is approved.</li>
            </ul>
            <div>
                In the first instance, please spell out and explain all acronyms used. Vivli may request that you revise your request and
                spell out acronyms, before moving your request forward.
            </div>
            <br />
            <div>Note that this summary will be published on the Vivli website if the request is approved.</div>
        </div>
    );
};
